import React from 'react';
import { useParams } from 'react-router-dom';
import LocationManagement from './LocationManagement';

const LocationViewPage: React.FC = () => {
  const { viewId } = useParams<{ viewId: string }>();
  return <LocationManagement standaloneViewId={viewId} />;
};

export default LocationViewPage;
